const tiktopPixel_1 = "C297DIFMU8Q03RAIET90";
const tiktopPixel_2	= "C4QVKVVM5GFN4SM702B0";
const tiktopPixel	= tiktopPixel_2;
var swiperSection	= {};
var toastTimeout;
function dgsSession(obj = {}, type = 'open', prop = '', cont){
  if(type == "open"){
    var dgsSession 		= sessionStorage.getItem('dgs_session')
    dgsSession 			= (dgsSession === null) ? "" : dgsSession;
    dgsSession 			= (dgsSession != "") ? JSON.parse(dgsSession) : {};
    return dgsSession;
  }else if(type == "read"){
    return obj['__'+prop] = ('__'+prop in obj) ? obj['__'+prop] : {};
  }else if(type == "push"){
    obj['__'+prop] = cont;
    return obj;
  }else if(type == "save"){ 
    sessionStorage.setItem('dgs_session',JSON.stringify(obj));
    //console.info(JSON.stringify(obj));
  }
}
function decodeLiquidData(encoded){
  var encoded	= parseFloat(encoded);
  var decoder1 	= parseInt(new Date().getFullYear());
  var decoder2 	= parseInt(new Date().getMonth()) + 1;
  return Math.round((encoded / decoder2) * decoder1);
}
function encodeLiquidData(decoded){
  var decoded	= parseFloat(decoded);
  var encoder1 	= parseInt(new Date().getFullYear());
  var encoder2 	= parseInt(new Date().getMonth()) + 1;
  return Math.round((decoded / encoder1) * encoder2);
}
function getCurrentRedirect(){
  var currentURL	 	= window.location.href;
  var uselessURL	  	= window.location.protocol + '//' + window.location.hostname;
  var currentRedirect 	= currentURL.replace(uselessURL,"");
  return currentRedirect;
}
//console.log(window.location);
function findGetParameter(parameterName){
  var result 	= null;
  var tmp 		= [];
  var items 	= location.search.substr(1).split("&");
  for(var index = 0; index < items.length; index++){
    tmp = items[index].split("=");
    if(tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
}
function hasNumber(str){ return /\d/.test(str); }
setAddDataLayer = function(lineItem) {
  console.log("lineItem",lineItem);
  if (typeof lineItem !== "undefined" && lineItem) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "addToCart",
      "ecommerce": {
        "currencyCode": "EUR",
        "add": {
          "products": [{
            "name": lineItem.product_title,
            "id": lineItem.handle,
            "sku": lineItem.sku,
            "price": lineItem.price / 100,
            "brand": lineItem.vendor,
            "category": lineItem.product_type,
            "variant": lineItem.variant_title,
            "quantity": lineItem.quantity
          }]
        }
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", function(event) {
  document.body.setAttribute("loaded","");
});